import {
    columnFacetingFeature,
    columnFilteringFeature,
    columnGroupingFeature,
    columnOrderingFeature,
    columnPinningFeature,
    columnResizingFeature,
    columnSizingFeature,
    columnVisibilityFeature,
    createExpandedRowModel,
    createFacetedMinMaxValues,
    createFacetedRowModel,
    createFacetedUniqueValues,
    createFilteredRowModel,
    createGroupedRowModel,
    createPaginatedRowModel,
    createSortedRowModel,
    globalFilteringFeature,
    rowAggregationFeature,
    rowExpandingFeature,
    rowPaginationFeature,
    rowPinningFeature,
    rowSelectionFeature,
    rowSortingFeature,
    tableFeatures,
} from '@tanstack/react-table';

import { MRT_AggregationFns } from '../fns/aggregationFns';
import { MRT_FilterFns } from '../fns/filterFns';
import { MRT_SortingFns } from '../fns/sortingFns';

export function createMRTTableFeatures({
    aggregationFns = MRT_AggregationFns,
    filterFns = MRT_FilterFns,
    sortFns = MRT_SortingFns,
}: {
    aggregationFns?: Record<string, any>;
    filterFns?: Record<string, any>;
    sortFns?: Record<string, any>;
} = {}) {
    return tableFeatures({
        columnVisibilityFeature,
        columnOrderingFeature,
        columnPinningFeature,
        columnSizingFeature,
        columnResizingFeature,
        columnFilteringFeature,
        globalFilteringFeature,
        rowSortingFeature,
        rowPaginationFeature,
        rowSelectionFeature,
        rowExpandingFeature,
        rowPinningFeature,
        rowAggregationFeature,
        columnGroupingFeature,
        columnFacetingFeature,
        filteredRowModel: createFilteredRowModel(),
        sortedRowModel: createSortedRowModel(),
        paginatedRowModel: createPaginatedRowModel(),
        expandedRowModel: createExpandedRowModel(),
        groupedRowModel: createGroupedRowModel(),
        facetedRowModel: createFacetedRowModel(),
        facetedMinMaxValues: createFacetedMinMaxValues(),
        facetedUniqueValues: createFacetedUniqueValues(),
        filterFns,
        sortFns,
        aggregationFns,
    });
}

export const mrtTableFeatures = createMRTTableFeatures();

export type MRT_TableFeatures = typeof mrtTableFeatures;
